'use strict';

var _ = require('lodash');

module.exports = /* @ngInject */ ["apiFactory", "REF_DATA_API_BASE", "eikonSsoService", function (apiFactory,
                                           REF_DATA_API_BASE,
                                           eikonSsoService) {
  var that = this;

  that.create = function () {
    return apiFactory.create('refDataAddress', REF_DATA_API_BASE);
  };

  that.createWithEikonTokenHeader = function () {
    return eikonSsoService.getEikonSsoCookie().then(function (cookies) {
      return that.create().then(function (refDataApi) {
        return refDataApi.withConfig(function (config) {
          config.setDefaultHeaders({
            'Eikon-Token': eikonSsoService.extractEikonToken(cookies)
          });
        });
      });
    });
  };

  that.createWithEikonTokenHeaderOrWithoutIt = function () {
    return that.createWithEikonTokenHeader().then(function (api) {
      return api;
    }, function () {
      return that.create();
    });
  };
}];



//////////////////
// WEBPACK FOOTER
// /app/~/redi-refdata-web-lib/dist/infrastructure/refDataApiFactory.js
// module id = 131
// module chunks = 0